<template>
    <b-container class="wrapper h-100" fluid>
        <b-row class="" align-v="center" align-h="center">
            <b-col class="center-msg" col xs="10" sm="10" md="10" xl="6" lg="8" >
                <h1><span>Política de Cookies</span>.</h1>
                <p>Una cookie (galleta o galleta informática) es un pequeño fichero de texto enviada por un sitio web y almacenada en tu navegador, de manera que el sitio web puede recordar información de actividad previa del navegador.</p>
                <p>Si desea conocer más sobre qué son las cookies, qué almacenan, cómo eliminarlas, desactivarlas, etc. le recomendamos leer el enlace correspondiente a su navegador:</p>
                <ul>
                    <li><a href="https://support.google.com/accounts/answer/61416?hl=es&co=GENIE.Platform%3DDesktop&oco=1" target="_blank">Google Chrome</a></li>
                    <li><a href="https://support.mozilla.org/es/kb/cookies-informacion-que-los-sitios-web-guardan-en-" target="_blank">Mozilla Firefox</a></li>
                    <li><a href="https://support.apple.com/es-mx/guide/safari/sfri11471/mac" target="_blank">Safari</a></li>
                    <li><a href="https://support.microsoft.com/es-mx/help/4468242/microsoft-edge-browsing-data-and-privacy" target="_blank">Microsoft Edge</a></li>
                </ul>
                <h2>Cookies utilizadas en este sitio web</h2>
                <p>En este sitio web se emplean dos tipos de cookies las propias y las de terceros, las cuales tienen los siguientes objetivos:</p>
                <h3>Propias:</h3>
                <p>-</p>
                <h3>Terceros:</h3>
                <p><span>Google Analytics</span>
                    <br>— Nos permite generar estadísticas sobre el tráfico, acciones, tiempo de uso, tipo de dispositivo de consulta entre otros, con la finalidad de identificar las áreas de oportunidad para mejorar nuestro sitio web.
                    <br>— Para más información te invitamos a conocer la <a href="https://policies.google.com/privacy?hl=es" target="_blank">política de uso de datos de google</a>.
                </p>
                <p><span>Facebook Pixel</span>
                    <br>— Nos permite generar campañas de difusión para llegar a la audiencia más afín a nuestro contenido con la finalidad de conectar con la comunidad a quien mayor valor le podamos entregar.
                    <br>— Para más información te invitamos a conocer la <a href="https://www.facebook.com/privacy/explanation" target="_blank">política de uso de datos de facebook</a>.
                </p>
                <h2>Eliminar o desactivar cookies</h2>
                <p>En cualquier momento podrás ejercer tu derecho a eliminar o desactivar las cookies en tu navegador. Accede a nuestra  guía rápida para los navegadores más populares para conocer cómo hacerlo.</p>
                <h2>Notas adicionales</h2>
                <p>— Ni esta web ni sus representantes legales se hacen responsables ni del contenido ni de la veracidad de las políticas de privacidad que puedan tener los terceros mencionados en esta política de cookies.</p>
                <p>— Los navegadores web son las herramientas encargadas de almacenar las cookies y desde este lugar debe efectuar su derecho a eliminar o desactivar las mismas. Ni esta web ni sus representantes legales pueden garantizar la correcta o incorrecta manipulación de las cookies por parte de los mencionados navegadores.</p>

                <h1><span>Guía rápida de desactivación de cookies</span>.</h1>
                <p>A continuación le indicamos cómo acceder a una cookie determinada del navegador Chrome. (estos pasos pueden variar en función de la versión del navegador):</p>
                <ol>
                    <li>Vaya a Configuración o Preferencias mediante el menú Archivo o bien pinchando el icono de personalización que aparece arriba a la derecha.</li>
                    <li>Verá diferentes secciones, pinche la opción Mostrar opciones avanzadas.</li>
                    <li>Vaya a Privacidad, Configuración de contenido.</li>
                    <li>Seleccione Todas las cookies y los datos de sitios.</li>
                    <li>Aparecerá un listado con todas las cookies ordenadas por dominio. Para que le sea más fácil encontrar las cookies de un determinado dominio introduzca parcial o totalmente la dirección en el campo Buscar cookies.</li>
                    <li>Tras realizar este filtro aparecerán en pantalla una o varias líneas con las cookies de la web solicitada. Ahora sólo tiene que seleccionarla y pulsar la X para proceder a su eliminación.</li>
                </ol>
                <p>Para acceder a la configuración de cookies del navegador Internet Explorer siga estos pasos (pueden variar en función de la versión del navegador):</p>
                <ol>
                    <li>Vaya a Herramientas, Opciones de Internet.</li>
                    <li>Haga click en Privacidad.</li>
                    <li>Mueva el deslizador hasta ajustar el nivel de privacidad que desee.</li>
                </ol>
                <p>Para acceder a la configuración de cookies del navegador Firefox siga estos pasos (pueden variar en función de la versión del navegador):</p>
                <ol>
                    <li>Vaya a Opciones o Preferencias según su sistema operativo.</li>
                    <li>Haga click en Privacidad.</li>
                    <li>En Historial elija Usar una configuración personalizada para el historial.</li>
                    <li>Ahora verá la opción Aceptar cookies, puede activarla o desactivarla según sus preferencias.</li>
                </ol>
                <p>Para acceder a la configuración de cookies del navegador Safari para OSX siga estos pasos (pueden variar en función de la versión del navegador):</p>
                <ol>
                    <li>Vaya a Preferencias, luego Privacidad.</li>
                    <li>En este lugar verá la opción Bloquear cookies para que ajuste el tipo de bloqueo que desea realizar.</li>
                </ol>
                <p>Para acceder a la configuración de cookies del navegador Safari para iOS siga estos pasos (pueden variar en función de la versión del navegador):</p>
                <ol>
                    <li>Vaya a Ajustes, luego Safari.</li>
                    <li>Vaya a Privacidad y Seguridad, verá la opción Bloquear cookies para que ajuste el tipo de bloqueo que desea realizar.</li>
                </ol>
                <p>Para acceder a la configuración de cookies del navegador para dispositivos Android siga estos pasos (pueden variar en función de la versión del navegador):</p>
                <ol>
                    <li>Ejecute el navegador y pulse la tecla Menú, luego Ajustes.</li>
                    <li>Vaya a Seguridad y Privacidad, verá la opción Aceptar cookies para que active o desactive la casilla.</li>
                </ol>
                <h4>Fecha de última modificación: <span>24 de abril del 2020</span></h4>

            </b-col>
        </b-row>
    </b-container>
</template>

<script>

import { eventBus } from '../main'

export default {
    name: 'Home',
    data() {
        return {}
    },
    metaInfo() {
        return {
            title: 'Política de uso de Cookies | Ozmo',
            meta: [
                {name: 'description', content: 'Consultora en Innovación Estratégica'},
                {name: 'keywords', content: 'consultora en innovación estratégica, consultora de innovación, agencia de transformación estratégica, consultora de cultura organizacional, consultoría en transformación para empresas, consultoría en cultura organizacional, proveedores de design thinking, agencias de investigación de usuarios, talleres para diseñar experiencias, consultoras con experiencia en área de capital humano, consultoras en innovación con experiencia sector financiero, agencia de innovación empresarial'},
                {name: 'robots', content: 'index,follow'},
                {name: 'viewport', content: 'width=device-width,initial-scale=1,user-scalable=no' },
                {charset: 'utf-8' },
                {property: 'og:title', content: 'Política de uso de Cookies'},
                {property: 'og:site_name', content: 'Ozmo | Diseño de futuros'},
                {property: 'og:description', content: 'Consultora en Innovación Estratégica'},
                {property: 'og:url', content: 'https://ozmo.mx'},
                {property: 'og:type', content: 'website'},
                {property: 'og:image', content: 'https://s3-us-west-2.amazonaws.com/cdn.ozmo.mx/ozmo_coral.png'}
            ]
        }
    },
    mounted() {
        // let wrapperHeight = document.getElementsByClassName("wrapper")[0].scrollHeight
        // let overlayHeight = document.getElementsByClassName("overlay-top")[0].offsetHeight
        // let windowHeight = wrapperHeight - overlayHeight
        // this.$store.dispatch('commitWindowHeight', windowHeight)
    },
    methods: {
        goto(navigation) {
            eventBus.$emit('gotoNavigation', navigation)
        }
    },
    created() {
        eventBus.$emit('displayOverlay')
    }
}
</script>

<style scoped lang="stylus">

.wrapper
    width 100vw
    overflow-x hidden
    overflow-y scroll

    .center-msg
        margin 25rem 0
        position relative
        z-index 15

        h1
            line-height 88px
            txt_style($archia-m, 80px, #3a3a3a)

            span
                txt_style($archia-m, 80px, #3a3a3a)
                text-decoration underline

        h2
            margin-top 10rem
            txt_style($worksans-r, 24px, $ozmo-blue)

        h3
            margin 5rem 0
            txt_style($worksans-m, 24px, #3a3a3a)

        h4
            text-align right
            margin 10rem 0
            txt_style($worksans-r, 16px, #3a3a3a)

            span
                txt_style($worksans-m, 16px, #3a3a3a)

        p
            margin 10rem 0
            txt_style($worksans-r, 24px, #3a3a3a)

            span
                txt_style($worksans-m, 24px, #3a3a3a)

        a
            txt_style($worksans-m, 24px, $ozmo-coral)
            text-decoration underline

        li
            txt_style($worksans-r, 24px, #3a3a3a)

@media (max-width 767px)
    .center-msg
        margin 100px 0 !important 
        position relative
        z-index 15

        h1
            line-height 40px
            txt_style($archia-m, 32px, #3a3a3a)

            span
                txt_style($archia-m, 32px, #3a3a3a)
                text-decoration underline     

        p
            margin 5rem 0
            txt_style($worksans-r, 16px, #3a3a3a)

            span
                txt_style($worksans-m, 16px, #3a3a3a)  
</style>
